// Vanilla reimplementation of Bootstrap 4's declarative dropdown API (data-toggle="dropdown").
// Drives the language-switcher dropdowns in header.twig (#siteHeaderLangToggle,
// #siteHeaderLangToggleMobile) — existing .dropdown/.dropdown-menu markup and CSS
// (static/src/lib/bootstrap.css) are unchanged, only the JS engine is replaced.

function closeAllDropdowns(except) {
    document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
        if (menu === except) return;
        menu.classList.remove('show');
        const toggle = menu.previousElementSibling;
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
}

document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-toggle="dropdown"]');

    if (toggle) {
        event.preventDefault();
        const menu = toggle.nextElementSibling;
        if (!menu || !menu.classList.contains('dropdown-menu')) return;

        const isOpen = menu.classList.contains('show');
        closeAllDropdowns();

        if (!isOpen) {
            menu.classList.add('show');
            toggle.setAttribute('aria-expanded', 'true');
        }
        return;
    }

    if (!event.target.closest('.dropdown-menu')) closeAllDropdowns();
});

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllDropdowns();
});
